import styled from '@emotion/styled';

export const FriendListUl = styled.ul`
  display: flex;
  width: 300px;
  flex-direction: column;
  margin: 0 auto;
  list-style-type: none;
  padding: 0;
  padding-top: 30px;
  padding-bottom: 30px;
  background-color: lightgoldenrodyellow;
`;
export const Item = styled.li`
  display: flex;
  margin-bottom: 30px;
  align-items: center;
  justify-content: center;
`;
